// extracted by mini-css-extract-plugin
export default {"chip":"Chips_chip__t1Oh9","chipsList":"Chips_chipsList__niufK","fadeIn":"Chips_fadeIn__tcYxO","iconShake":"Chips_iconShake__-w9Ae"};